import React from 'react';

import { MoreMediaArticlesSectionProps } from './types/MoreMediaArticlesSection.types';
import { ArticleCard } from '../pageBuilder/Elements/ArticleCard';
import {
  MoreMediaArticleCardsContainer,
  MoreMediaArticlesHeader,
  MoreMediaArticlesWrapper,
} from './styles/MoreMediaArticlesSection.styles';

const MoreMediaArticlesSection = ({
  articles,
  articleIndexSlug,
  seoTitle,
  readingTimeMinuteLabel,
  displaySaveIcon,
  saveLabelText,
  moreMediaHeader,
  saveIconClicked,
}: MoreMediaArticlesSectionProps) => {
  const articleCards = articles.map(article => {
    return (
      <ArticleCard
        isAnimated={true}
        isMedia={true}
        isFeatured={false}
        key={article.id}
        indexSlug={articleIndexSlug}
        data={article}
        backgroundColor={'gallery'}
        seoTitle={seoTitle}
        readingTimeMinuteLabel={readingTimeMinuteLabel}
        displaySaveIcon={displaySaveIcon}
        saveLabelText={saveLabelText}
        handleSaveClick={saveIconClicked}
      />
    );
  });
  return (
    <MoreMediaArticlesWrapper>
      <MoreMediaArticlesHeader>{moreMediaHeader}</MoreMediaArticlesHeader>
      <MoreMediaArticleCardsContainer
        isSingle={articles.length > 1 ? false : true}
      >
        {articleCards}
      </MoreMediaArticleCardsContainer>
    </MoreMediaArticlesWrapper>
  );
};

export default MoreMediaArticlesSection;
